var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { object } from 'prop-types';
import React, { useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import { useDispatch } from 'react-redux';
import PermissionChecker from '~/components/permission_checker';
import { useUser } from '~/providers/user';
import { addComment } from '~/redux/reducers/states/comparison_documents';
import Permissions from '~/settings/permissions';
import { PostCommentButton } from './post-comment';
const CommentInput = (_a) => {
    var { ids } = _a, rest = __rest(_a, ["ids"]);
    CommentInput.propTypes = {
        ids: object,
    };
    const { taggableComparisonUsers } = useUser();
    const dispatch = useDispatch();
    const [commentText, setCommentText] = useState('');
    const [taggedUserIds, setTaggedUserIds] = useState([]);
    const { classificationId, documentComparisonFileId } = ids;
    const handlePostComment = selectedPrivilegeGroups => {
        if (!commentText) {
            return;
        }
        const formattedText = commentText.replace(/\[(.*?)\]/gi, '');
        dispatch(addComment({
            classificationId,
            documentComparisonFileId,
            text: formattedText,
            privilegeGroups: selectedPrivilegeGroups,
            taggedUserIds,
        }));
        setCommentText('');
        setTaggedUserIds([]);
    };
    const handleChange = (event, newValue, plainTextValue, mentions) => {
        setCommentText(newValue);
        setTaggedUserIds(mentions.map(mention => mention.id));
    };
    const users = taggableComparisonUsers.map(user => (Object.assign(Object.assign({}, user), { display: user.name })));
    return (React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.CREATE_CLAUSE_COMMENTS] },
        React.createElement("div", Object.assign({ className: 'comment-input' }, rest),
            React.createElement("div", { className: 'add-comment-input' },
                React.createElement(MentionsInput, { placeholder: 'Add your thoughts. Mention others with \'@\'', value: commentText, onChange: handleChange, className: 'mentions' },
                    React.createElement(Mention, { trigger: '@', data: users, markup: '{uid:__id__[__display__]}', displayTransform: (id, display) => `@${display}`, className: 'mentions__mention' }))),
            React.createElement("div", { className: 'comment-actions' },
                React.createElement(PostCommentButton, { taggedUserIds: taggedUserIds, disabled: commentText === '', handlePost: handlePostComment })))));
};
export default CommentInput;
